export default __webpack_public_path__ + "static/media/3b.0c3d4cdf.jpg";